<div class="wrapper flex flex-col justify-between">
  <div class="heading flex flex-row items-center justify-between mb-[40px]">
    <div class="text-type-2">
      {{ isEditMode ? (data?.material?.name || 'Edit material') : 'Create material' }}
    </div>
  </div>
  <div class="details flex-1" [formGroup]="form">
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['name']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="name"
      label="Name"
    />
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['uom']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="uom"
      label="UOM"
    />

    <div class="flex flex-row justify-between items-center mb-[40px] gap-[20px] w-full">
      <div class="label text-type-13 uppercase">Track Received</div>
      <mat-slide-toggle
        formControlName="track_received"
        [disableRipple]="false"
        class="slide-toggle-btn"
        color="primary"
      ></mat-slide-toggle>
    </div>

    <div class="flex flex-row justify-between items-center mb-[40px] gap-[20px] w-full">
      <div class="label text-type-13 uppercase">Track Used</div>
      <mat-slide-toggle
        formControlName="track_used"
        [disableRipple]="false"
        class="slide-toggle-btn"
        color="primary"
      ></mat-slide-toggle>
    </div>
  </div>
  <div class="action-section w-full flex justify-between items-center gap-[10px] mt-[40px]">
    <app-secondary-button (handleClick)="cancel()" class="w-full">Cancel</app-secondary-button>
    <app-primary-button (handleClick)="submit()" [isDisabled]="!isFormDirty" class="w-full">
      {{ isEditMode ? 'Update' : 'Create' }}
    </app-primary-button>
  </div>
</div>
